<div class="stock-section">
  <div class="stock-list-meta" *ngIf="!loading">
    Mostrando {{ stockMovements.length }} di {{ count }} movimenti
  </div>

  <div class="stock-error" *ngIf="errorMessage">
    {{ errorMessage }}
  </div>

  <p class="stock-loading" *ngIf="loading">
    Caricamento movimenti di stock...
  </p>

  <div class="stock-table-wrap" *ngIf="!loading && stockMovements.length">
    <table class="stock-table">
      <thead>
        <tr>
          <th>Data</th>
          <th>Tipo</th>
          <th>Motivo</th>
          <th>Quantità</th>
          <th>Consegna</th>
          <th>Riga stock</th>
        </tr>
      </thead>

      <tbody>
        <tr *ngFor="let movement of stockMovements">
          <td>{{ movement.createdAt | date: 'short' }}</td>
          <td>
            <span
              class="type-pill"
              [class.inbound]="movement.type === 'INBOUND'"
              [class.outbound]="movement.type === 'OUTBOUND'"
            >
              {{ movement.type }}
            </span>
          </td>
          <td>{{ movement.reason }}</td>
          <td>
            <strong>{{ movement.quantity }}</strong>
          </td>
          <td>{{ movement.delivery?.id || '-' }}</td>
          <td>{{ movement.stockLine?.id || '-' }}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div class="empty-state" *ngIf="!loading && !stockMovements.length && !errorMessage">
    Nessun movimento di stock trovato con i filtri attuali.
  </div>

  <div class="stock-pagination" *ngIf="!loading && count > limit">
    <button type="button" (click)="prevPage()" [disabled]="page <= 1">
      Precedente
    </button>

    <span>
      Pagina {{ page }} di {{ totalPages }}
    </span>

    <button type="button" (click)="nextPage()" [disabled]="page >= totalPages">
      Successiva
    </button>
  </div>
</div>